import React from 'react'

import { Button } from '@interco/inter-toranja'
import type { Hierarchy } from '@interco/inter-toranja/dist/types/shared'

interface ButtonProps {
  text?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  hierarchy?: Hierarchy
}

export const ButtonComponent: React.FC<ButtonProps> = ({
  text,
  onClick,
  hierarchy = 'primary',
}) => {
  if (!onClick) return <></>
  return (
    <Button
      data-testid="button-try-again"
      label={text}
      onClick={onClick}
      hierarchy={(hierarchy as Hierarchy) || ('primary' as Hierarchy)}
    />
  )
}
